import { SYSTEM_TABS } from 'constants/navs'
import NavTabs from '../NavTabs'

const SystemNav = () => <NavTabs tabs={SYSTEM_TABS} />

export default SystemNav
